module.exports = __webpack_public_path__ + "static/media/Homepage2.69f2b0bd.jpg";